
import Vue from "vue";

Vue.filter('icon', function (val) {
    let icons = [
        { value: 0, text: "info" },
        { value: 1, text: "warning" },
        { value: 2, text: "alarm" },
        { value: 3, text: "announcement" },
        { value: 4, text: "calendar_today" },
        { value: 6, text: "date_range" },
        { value: 7, text: "event" },
        { value: 8, text: "feedback" },
        { value: 9, text: "grade" },
        { value: 10, text: "flight_land" },
        { value: 11, text: "flight_takeoff" },
        { value: 12, text: "important_devices" },
        { value: 14, text: "language" },
        { value: 15, text: "perm_device_information" },
        { value: 16, text: "schedule" },
        { value: 17, text: "question_answer" },
        { value: 18, text: "report_problem" },
        { value: 19, text: 'room' },
        { value: 20, text: 'stars' },
        { value: 21, text: 'swap_horiz' },
        { value: 22, text: 'sync' },
        { value: 23, text: 'timeline' },
        { value: 24, text: 'today' },
        { value: 25, text: 'view_list' },
        { value: 26, text: 'work' },
        { value: 27, text: 'notifications' },
        { value: 29, text: 'play_arrow' },
        { value: 30, text: 'call' },
        { value: 31, text: 'chat' },
        { value: 32, text: 'email' },
        { value: 33, text: 'mail_outline' },
        { value: 34, text: 'flag' },
        { value: 35, text: 'report' },
        { value: 36, text: 'highlight' },
        { value: 37, text: 'smartphone' },
        { value: 38, text: 'camera_alt' },
        { value: 39, text: 'color_lens' },
        { value: 40, text: 'edit' },
        { value: 41, text: 'image' },
        { value: 42, text: 'movie_creation' },
        { value: 43, text: 'directions_bus' },
        { value: 44, text: 'directions_car' },
        { value: 45, text: 'directions_railway' },
        { value: 46, text: 'flight' },
        { value: 47, text: 'directions_subway' },
        { value: 48, text: 'directions_walk' },
        { value: 49, text: 'hotel' },
        { value: 51, text: 'local_hospital' },
        { value: 52, text: 'local_parking' },
        { value: 53, text: 'local_taxi' },
        { value: 54, text: 'map' },
        { value: 55, text: 'restaurant' },
        { value: 56, text: 'restaurant_menu' },
        { value: 57, text: 'event_available' },
        { value: 58, text: 'wifi' },
        { value: 59, text: 'free_breakfast' },
        { value: 60, text: 'room_service' },
        { value: 63, text: 'location_city' },
        { value: 64, text: 'looks' },
        { value: 65, text: 'panorama' },
        { value: 66, text: 'atm' },
        { value: 67, text: 'local_cafe' },
        { value: 68, text: 'local_library' },
        { value: 69, text: 'local_mall' },
        { value: 70, text: 'local_movies' },
        { value: 71, text: 'menu' },
        { value: 72, text: 'wc' }
    ];

    let matches = icons.filter(i => i.value == val);
    return matches.length ? matches[0].text : 'notifications';
});